<div class="retorno-wrapper" [class.disabled]="disabled">
  <mat-form-field appearance="outline" class="retorno-input">
    <mat-label>{{ placeholder }}</mat-label>
    <input
      matInput
      [value]="selectedDateFormat"
      readonly
      (click)="!disabled && (openPopup = true)"
      [disabled]="disabled"
    />
    <mat-icon (click)="!disabled && (openPopup = true)" matSuffix>calendar_today</mat-icon>
  </mat-form-field>

  <div class="popup" *ngIf="openPopup && !disabled">
    <mat-calendar
      [headerComponent]="customHeader"
      [(selected)]="selectedDate"
      (selectedChange)="onCalendarDateSelected($event)"
      [startAt]="selectedDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
    ></mat-calendar>

    <div class="steppers" *ngIf="!dateOnly">
      <div class="stepper">
        <button (click)="adjustHour(1)" [disabled]="disabled">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <div>{{ two(hour) }}</div>
        <button (click)="adjustHour(-1)" [disabled]="disabled">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>

      <span>:</span>

      <div class="stepper">
        <button (click)="adjustMinute(1)" [disabled]="disabled">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <div>{{ two(minute) }}</div>
        <button (click)="adjustMinute(-1)" [disabled]="disabled">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>

      <div class="stepper">
        <button (click)="togglePeriod()" [disabled]="disabled">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <div>{{ period }}</div>
        <button (click)="togglePeriod()" [disabled]="disabled">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>

    <div class="acoes">
      <button mat-stroked-button class="btn-outline" (click)="cancel()">Cancelar</button>
      <button mat-flat-button class="btn-primary" (click)="confirm()">
        {{ dateOnly ? 'Selecionar' : 'Atualizar' }}
      </button>
    </div>
  </div>
</div>
